import { c as _c } from "react/compiler-runtime";
import SVGelem from '@components/SVGelem/SVGelem';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { useViewport } from '@lib/tools/hooks/useViewport';
import Link from 'next/link';
import style from './Term.module.scss';
const TermItem = t0 => {
  const $ = _c(11);
  const {
    value,
    path,
    description
  } = t0;
  const {
    isMobile
  } = useViewport();
  let t1;
  if ($[0] !== value) {
    t1 = <p className={style.term__title}>{value}</p>;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = description || "";
  let t3;
  if ($[2] !== t2) {
    t3 = <SafeHtmlRenderer className={style.term__desc} tag="p" content={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isMobile) {
    t4 = isMobile && <SVGelem className={style.term__icon} href="#arrow" />;
    $[4] = isMobile;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== path || $[7] !== t1 || $[8] !== t3 || $[9] !== t4) {
    t5 = <Link href={path} className={style.term}>{t1}{t3}{t4}</Link>;
    $[6] = path;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default TermItem;